(ns common.schema.entities.survey.survey-profile-status
  (:require
   [common.util :as cu]))

(def options
  [{:key   :survey-profile.status/not-started
    :label "Not started"}
   {:key   :survey-profile.status/missing
    :label "Missing"}
   {:key   :survey-profile.status/valid
    :label "Valid"}])

(defn label
  [status]
  (->> options
       (cu/filter-by :key status)
       (first)
       :label))
